import { render, staticRenderFns } from "./UsersTableComponent.vue?vue&type=template&id=58b5ca53&scoped=true&"
import script from "./UsersTableComponent.vue?vue&type=script&lang=js&"
export * from "./UsersTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./UsersTableComponent.vue?vue&type=style&index=0&id=58b5ca53&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5ca53",
  null
  
)

export default component.exports